import React from 'react';
import type { PaletteMode } from '@mui/material';

export interface ThemeModeContextValue {
  mode: PaletteMode;
  toggleMode: () => void;
}

export const ThemeModeContext = React.createContext<ThemeModeContextValue>({
  mode: 'light',
  toggleMode: () => undefined,
});
